
module.directive('dybQuery', function(ApiUrl, QueryStringFilter) {
    return {
        restrict: 'E',
        scope: {config:'&', data: '='},
        controller: ['$scope', '$attrs', function($scope, $attrs) {

            var watchOnce = angular.noop;
            var controller = this;

            this.config = $scope.config();
            this.filter = QueryStringFilter(this.config.filters);
            this.items = [];

            $scope.data = this;

            function filterParams() {
                return controller.filter.params(controller.config.defaultFilters);
            }

            function getApiRequest() {
                var config = controller.config;
                return config.model.$index(filterParams());
            }

            function updateData(newFilter, oldFilter) {
                if(oldFilter && newFilter.page == oldFilter.page) {
                    controller.filter.page = 1;
                }
                controller.refresh();
            }

            this.refresh = function() {
                getApiRequest().then(function(data) {
                    controller.items = data;
                    controller.meta = data.meta;
                    controller.filter.toQueryString();
                });
            };

            $scope.$watch(function() {
                return filterParams();
            }, updateData, true);

        }],
    };
});